import Footer from '@/layouts/Footer';
import React from 'react';
import { Outlet } from 'react-router-dom';

const LayoutMain = () => {
  return (
    <div className="layout-main">
      <Outlet />
      <Footer />
    </div>
  );
};

export default LayoutMain;
